// @flow
import React, { Component } from 'react';
import { Button, Divider, Form, Header, Label, Loader } from 'semantic-ui-react';
import {
    getAlert,
    getDeliveryMethods,
    getStoredProcedures,
    getNotificationUsers,
    saveAlert,
    sendAdHoc,
} from '../../modules/client';
import { PLATFORM_APP_ID } from '../../modules/consts';

type State = {
    methods: Array<DeliveryMethod>,
    procedure: ?string,
    procedures: Array<StoredProcedure>,
    pushMessage: string,
    smsMessage: string,
    phone: string,
    saving: boolean,
    subject: string,
    userId: ?string,
    users: Array<User>,
};
type Props = {
    clientId: Guid,
    match: Object,
};

const TEXT_TEMPLATE = `{{body}}\n{{attachments}}`;

export default class Alert extends Component<Props, State> {
    constructor() {
        super();
        this.state = {
            methods: [],
            procedure: undefined,
            procedures: [],
            pushMessage: '',
            smsMessage: '',
            phone: '',
            saving: false,
            subject: '',
            userId: undefined,
            users: [],
        };
    }
    componentDidMount() {
        const alertId = this.props.match.params.alertId || false;
        Promise.all([
            alertId && getAlert(alertId),
            getDeliveryMethods(),
            getStoredProcedures(this.props.clientId, ''), //TODO fix the getting of stored procs
            getNotificationUsers(),
        ])
            .then(([alertData, methods, sprocs, users]) => {
                const types = methods.filter(
                    (item) => item.Name === 'PushNotification' || item.Name === 'Sms'
                );

                if (alertData) {
                    const { Email, Phone, PushMessage, SMSMessage, SprocName, Subject } = alertData;
                    this.setState({
                        phone: Phone,
                        pushMessage: PushMessage,
                        smsMessage: SMSMessage,
                        methods: types,
                        procedure: SprocName,
                        procedures: sprocs,
                        subject: Subject,
                        userId: Email,
                        users: users,
                    });
                } else {
                    this.setState({ methods: types, procedures: sprocs, users: users });
                }
            })
            .catch((err) => console.error(err));
    }
    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevProps.match.params.alertId !== this.props.match.params.alertId) {
            getAlert(this.props.match.params.alertId)
                .then((alertData) => {
                    const { Email, Phone, PushMessage, SMSMessage, SprocName, Subject } = alertData;
                    this.setState({
                        phone: Phone,
                        pushMessage: PushMessage,
                        smsMessage: SMSMessage,
                        procedure: SprocName,
                        subject: Subject,
                        userId: Email,
                    });
                })
                .catch((err) => console.error(err));
        }
    }

    // prettifyPhone(prev: string, next: string) {
    //     if (prev.length < next.length && prev.endsWith('-')) {
    //         return prev.slice(0, -1);
    //     }
    //     return next;
    // }
    onChange = (e: SyntheticEvent<HTMLFormElement>, data: { name: string, value: string }) => {
        this.setState({ [e.currentTarget.name || data.name]: data.value });
    };
    onChangeRecipient = (key: string, value: string) => {
        let newValue = value;
        // if (key === 'phone') {
        //     const prev = this.state[key];
        //     newValue = this.prettifyPhone(prev, value);
        // }
        this.setState({ [key]: newValue });
    };
    onSave = (e: SyntheticEvent<HTMLFormElement>) => {
        if (!this.state.saving) {
            this.setState({ saving: true });
            const { phone, procedure, pushMessage, smsMessage, subject, userId } = this.state;

            const data = {
                id: this.props.match.params.alertId,
                phone,
                procedure,
                pushMessage,
                smsMessage,
                subject,
                userId,
            };

            return saveAlert(data)
                .then((rs) => window.location.reload())
                .catch((err) => {
                    console.error(err);
                    this.setState({ saving: false });
                });
        }
        e.preventDefault();
    };
    getEndpointValue = (method: string): [Array<string> | ?string, string] => {
        const { phone, userId, users } = this.state;
        const user = users.find((el) => el.userId === userId);
        const endpoint = method === 'Sms' ? `+1${phone}` : user ? user.pushTokens : null;
        const value = this.state[`${method === 'Sms' ? 'smsMessage' : 'pushMessage'}`];
        return [endpoint, value];
    };
    onSend = (e: SyntheticEvent<HTMLFormElement>) => {
        if (!this.state.saving) {
            this.setState({ saving: true });
            const { methods, subject } = this.state;
            return Promise.all(
                methods
                    .filter((el) => {
                        const [endpoint, body] = this.getEndpointValue(el.Name);
                        return endpoint ? endpoint.length : null && body.length;
                    })
                    .map((method) => {
                        let [endpoint, body] = this.getEndpointValue(method.Name);
                        endpoint = Array.isArray(endpoint) ? endpoint : endpoint ? [endpoint] : [];
                        const actualEndpoint = endpoint.map((el) => ({
                            deliveryMethodId: method.Id,
                            value: el,
                        }));

                        const data = {
                            clientId: '90CF9062-5CAA-E711-80C2-00155DE1E378',
                            senderId: '5986C3EA-8687-47C2-A9CB-B07296C4B1D9',
                            appId: PLATFORM_APP_ID,
                            subject,
                            payload: { body: body },
                            plainTextTemplate: TEXT_TEMPLATE,
                            endpoints: actualEndpoint,
                        };
                        return sendAdHoc(data);
                    })
            )
                .then((rs) => this.setState({ saving: false }))
                .catch((err) => {
                    console.error(err);
                    this.setState({ saving: false });
                });
        }
        e.preventDefault();
    };
    render() {
        const props = this.props;
        const { methods, phone, procedure, procedures, userId } = this.state;

        if (!methods.length || !procedures.length) {
            return (
                <div>
                    <Loader active size="large">{`Loading...`}</Loader>
                </div>
            );
        }

        const sprocs = procedures.map((el) => ({ text: el.name, value: el.name }));
        const users = this.state.users.map((user) => ({ text: user.fullName, value: user.userId }));

        const TextArea = (key, label) => (
            <Form.TextArea
                name={key}
                label={label}
                onChange={this.onChange}
                value={this.state[key]}
            />
        );

        return (
            <div>
                <Header as="h2" className="c-page-header" content={'Alert'} />
                <Form id="newmessage" onSubmit={this.onSend} style={{ maxWidth: '50rem' }}>
                    <Form.Input
                        fluid
                        name="subject"
                        label="Name"
                        onChange={this.onChange}
                        value={this.state.subject}
                    />
                    <Form.Group>
                        <Form.Dropdown
                            defaultValue={procedure ? undefined : sprocs[0].value}
                            name="procedure"
                            label="Rule Procedure"
                            onChange={this.onChange}
                            options={sprocs}
                            value={procedure}
                            width={13}
                        />
                        <Button
                            content="Test"
                            icon="play"
                            onClick={() => {}}
                            positive
                            type="button"
                            width={3}
                        />
                    </Form.Group>
                    <Divider style={{ margin: '2rem 0' }} />
                    <Recipients
                        onChange={this.onChangeRecipient}
                        phone={phone}
                        userId={userId}
                        users={users}
                    />
                    {TextArea('smsMessage', 'SMS Message')}
                    {TextArea('pushMessage', 'Push Notification')}
                    <Button
                        content="Save"
                        floated="right"
                        icon="save"
                        loading={this.state.saving}
                        onClick={this.onSave}
                        primary
                    />
                    <Button
                        content="Send"
                        floated="right"
                        form="newmessage"
                        icon="send"
                        loading={this.state.saving}
                        primary
                        type="submit"
                    />
                </Form>
            </div>
        );
    }
}

function Recipients(props: Object) {
    return (
        <Form.Group widths="equal">
            <Form.Dropdown
                defaultValue={props.userId ? undefined : props.users[0].value}
                name="userId"
                label="User"
                onChange={(e, data) => props.onChange('userId', data.value)}
                options={props.users}
                value={props.userId}
                width={14}
            />
            <Form.Input
                label="Phone"
                name="phone"
                onChange={(e, data) => props.onChange('phone', data.value)}
                value={props.phone}
            />
        </Form.Group>
    );
}



// WEBPACK FOOTER //
// ./components/pages/Alert.jsx